import React from 'react'
import Inventory from '../../Components/Admin/Inventory/Inventory'

const AdminInventory = () => {
  return (
    <div className='p-5'>
      <Inventory  />
    </div>
  )
}

export default AdminInventory
